import { AxiosStatic } from "axios";
import { AnsweredQuestionWithId, Questionnaire } from "@teamprevent/common/questionnaires/model";

export class PpqApi {
    private readonly apiUrl = "/api/ppq";

    private axios: AxiosStatic;

    constructor(ax: AxiosStatic) {
        this.axios = ax;
    }

    public async loadManagerQuestionnaire(ohCaseId: string): Promise<Questionnaire> {
        const response = await this.axios.get(`${this.apiUrl}/${ohCaseId}/managerSection`);
        return response.data as Questionnaire;
    }

    public async submit(questions: AnsweredQuestionWithId[]): Promise<void> {
        await this.axios.post(`${this.apiUrl}`, { questions });
    }
}
